const state = () => ({
  isOpen: false,
  isEdit: true
})

const getters = {
  isOpen: state => state.isOpen
}

const actions = {
  openMenu ({ commit }) {
    commit('isOpen')
  }
}

const mutations = {
  isOpen: state => (state.isOpen = !state.isOpen),
  setIsEdit: (state, value) => (state.isEdit = value)
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
